import React, { useState } from 'react';
import {Dialog} from '@mui/material';
import RejectReason from '../../components/reusableComponents/RejectReason';

export default function RejectModal({ open, onClose, onConfirm }) {
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [otherMessage, setOtherMessage] = useState('');

  const handleCheckboxChange = (reason) => {
    setSelectedReasons((prev) => {
      if (prev.includes(reason)) {
        return prev.filter((r) => r !== reason);
      } else {
        return [...prev, reason];
      }
    });
  };

  const handleReject = () => {
    if (selectedReasons.length === 0) return;
    onConfirm(selectedReasons, otherMessage);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" sx={{ borderRadius: 3 }}>
      <RejectReason handleReject={handleReject} handleCheckboxChange={handleCheckboxChange} setOtherMessage={setOtherMessage} selectedReasons={selectedReasons} otherMessage={otherMessage} onClose={onClose} />
    </Dialog>
  );
}

